import { redirectFeatures } from "../rbac/features";
import { isPermissionAllowed } from "./permissionUtils";

/**
 * Returns the route of the first feature in redirectFeatures (sidenav order)
 * the caller has permission for, or "/unauthorized" if none match.
 */
export const resolveFirstAccessibleRoute = (hasPermission) => {
  for (const feature of redirectFeatures) {
    if (hasPermission(feature.permission)) {
      return feature.route;
    }
  }
  return "/unauthorized";
};

/**
 * Determines the best post-login redirect path based on permissions.
 *
 * 1. If postLoginRedirect exists in localStorage, use it (and clear it).
 * 2. Iterate the feature registry and return the first allowed feature's route.
 * 3. Fallback to "/unauthorized".
 */
export const resolvePostLoginRoute = (allowSet, denySet) => {
  // 1. Check for saved redirect (validate to prevent open redirect)
  const savedRedirect = localStorage.getItem("postLoginRedirect");
  if (savedRedirect) {
    localStorage.removeItem("postLoginRedirect");
    if (savedRedirect.startsWith("/") && !savedRedirect.startsWith("//")) {
      return savedRedirect;
    }
  }

  // 2. Find first allowed feature
  return resolveFirstAccessibleRoute((perm) =>
    isPermissionAllowed(perm, allowSet, denySet)
  );
};
